
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, watch, computed } from 'vue'
import { CaretRightOutlined, VerticalAlignBottomOutlined, CaretDownOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import globalsets from '@/utils/globalsets'
import api from '@/api/allApi'
import store from '@/store/index'
export default defineComponent({
  components: {
    VerticalAlignBottomOutlined,
    CaretRightOutlined,
    CaretDownOutlined
  },
  props: {
    data: {
      type: Array,
      default: function () {
        return []
      }
    },
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    bordered: Boolean,
    pagination: {
      type: [Boolean, Object],
      default: function () {
        return false || []
      }
    },
    scroll: {
      type: Object,
      default: function () {
        return {}
      }
    },
    emptyText: {
      type: Object,
      default: function () {
        return {}
      }
    },
    theme: {
      type: String,
      default: function () {
        return ''
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(props: any, context) {
    const route = useRoute()
    const pageData: any = reactive({
      emptystr: (props as any).emptyText,
      getPopupContainer: (e: HTMLElement) => e.parentNode,
      theme: props.theme || route.query.theme,
      activeRowId: '',
      inOptionalData: [] // 自选股
    })
    pageData.emptystr = (props as any).emptyText

    pageData.inOptionalData = computed(() => {
      const data = (store.state.OptionalList || []).filter((item: any) => {
        return item.groupType === 0
      })
      // 自选股
      let obj: any = {}
      if (data.length) obj = data[0]
      const result = (obj.stockList || []).map((item: any) => item.securityNo + '.' + item.securityMarket.toLowerCase())
      return result
    })
    const tooltip: any = reactive({})
    const overflow: any = reactive({})
    let timer: any = null
    function isoverflow(e: any, record: any, column: any) {
      const text = column.key
      const index = record.index
      tooltip[text + index] = e.currentTarget.scrollWidth > e.currentTarget.clientWidth
      if (tooltip[text + index]) {
        if (!timer) {
          timer = setTimeout(() => {
            overflow[text + index] = true
          }, 400)
        }
      }
    }
    function hidetool(record: any, text: string, column: any) {
      const index = record.index
      if (timer) {
        setTimeout(() => {
          overflow[column.key + index] = false
          window.clearTimeout(timer)
          timer = null
        })
      }
    }
    function handleClickRow(record: any, index: string, column: any) {
      return {}
    }
    function clickRow(record: any, index: string) {
      return {
        onClick: () => {
          pageData.activeRowId = record.index
          context.emit('clickRow', record.Name)
        },
        onDblclick: () => {
          context.emit('dbClickRow', record)
        }
      }
    }
    function setRowClassName(record: any) {
      const active = record.index === pageData.activeRowId ? 'activeRow' : ''
      return [active]
    }
    function getRowkey(record: any, index: number) {
      return record.index
    }
    function onChange(pagination: any, filters: any, sorter: any) {
      context.emit('onChange', { pagination, filters, sorter })
    }
    return {
      ...toRefs(pageData),
      tooltip,
      isoverflow,
      overflow,
      hidetool,
      getRowkey,
      onChange,
      handleClickRow,
      clickRow,
      setRowClassName,
      getNumber: globalsets.getNumber,
      getNumber2: globalsets.getNumber2,
      getPencent: globalsets.getPencent
    }
  }
})
